import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import template from './uploadStatusMessage.jsx';
import uploadStatuses from './uploadStatuses';

var getSplittedFileName = function getSplittedFileName(fileName) {
  return _.split(fileName, '.');
};

var getFileNamePrefix = function getFileNamePrefix(fileName) {
  var splittedFileName = getSplittedFileName(fileName);
  return splittedFileName[0] + (splittedFileName[1] ? '.' : '');
};

var UploadStatusMessage = /*#__PURE__*/function (_React$Component) {
  _inherits(UploadStatusMessage, _React$Component);

  var _super = _createSuper(UploadStatusMessage);

  function UploadStatusMessage(props) {
    var _this;

    _classCallCheck(this, UploadStatusMessage);

    _this = _super.call(this, props);

    _this.getMessage = function () {
      if (_this.props.status === uploadStatuses.UPLOAD_SUCCESS) {
        return getFileNamePrefix(_this.props.value);
      }

      if (_this.props.status === uploadStatuses.UPLOAD_FAILED) {
        return _this.props.errorMessage;
      }

      if (_this.props.status === uploadStatuses.IN_PROCESS) {
        return _this.props.processMessage;
      }
    };

    _this.getFileExtension = function () {
      return _this.props.status === uploadStatuses.UPLOAD_SUCCESS ? getSplittedFileName(_this.props.value)[1] || '' : '';
    };

    _this.isStatusNone = function () {
      return _this.props.status === uploadStatuses.NONE;
    };

    _this.isStatusUploadSuccess = function () {
      return _this.props.status === uploadStatuses.UPLOAD_SUCCESS;
    };

    _this.isStatusUploadFailed = function () {
      return _this.props.status === uploadStatuses.UPLOAD_FAILED;
    };

    _this.shouldTranslateMainMessage = function () {
      return _this.props.status === uploadStatuses.UPLOAD_SUCCESS ? false : _this.props.shouldTranslate;
    };

    _this.getEllipsisProps = function () {
      return {
        customTrigger: _assertThisInitialized(_this),
        displayCustomTrigger: true,
        customTooltipMessage: _this.getMessage() + _this.getFileExtension()
      };
    };

    return _this;
  }

  _createClass(UploadStatusMessage, [{
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return UploadStatusMessage;
}(React.Component);

UploadStatusMessage.displayName = displayNames.UPLOAD_BUTTON_STATUS_MESSAGE;
UploadStatusMessage.propTypes = {
  value: PropTypes.string,
  status: PropTypes.oneOf(uploadStatuses.UPLOAD_STATUS),
  errorMessage: PropTypes.string,
  processMessage: PropTypes.string
};
export default compose(UploadStatusMessage);